export default class MerchantFeature {
  public readonly isAdHiding: boolean;

  constructor(init?: MerchantFeatureInit) {
    this.isAdHiding = init ? init.isAdHiding : false;
  }
}

export interface MerchantFeatureInit {
  isAdHiding: boolean;
}
